export default __webpack_public_path__ + "static/media/back-arrow_dark.b96434db.svg";